import { Button } from '~/components/common/button';
import { Translate } from '~/i18n';
import { TickMark, InternationalMapIcon, SaudiMapIcon } from '~/svgs';
import { ReportIcon } from '~/svgs/marketplace';

export const OnBoardAccountType = ({
   accountTypeSelection,
}: {
   accountTypeSelection: (type: 'international' | 'domestic') => void;
}) => {
   const IntlUserFeatures = [
      'intl reseller feature 1',
      // 'intl reseller feature 2',
      // 'intl reseller feature 3',
   ];
   const IntlUserLegalDocs = ['intl reseller legal doc 1'];
   const DomesticUserFeature = [
      'domestic provider feature 1',
      'domestic provider feature 2',
      // 'domestic provider feature 3',
   ];
   const DomesticUserLegalDocs = [
      'domestic provider legal doc 1',
      'domestic provider legal doc 2',
      'domestic provider legal doc 3',
   ];

   return (
      <div className="h-full px-5 py-8">
         <div className="flex flex-col w-full lg:w-[350px] gap-0.5 mb-8">
            <span className="text-xs font-semibold text-grey-200">
               <Translate id="onboard:getting started" />
            </span>
            <span className="font-semibold">
               <Translate id="onboard:select type" />
            </span>
            <span className="text-xs text-grey-200">
               <Translate id="onboard:select type description" />
            </span>
         </div>

         <div className="flex flex-col gap-10 lg:flex-row">
            <div className="flex flex-col w-full py-6 bg-white rounded shadow-lg lg:w-1/2">
               <div className="flex flex-col gap-2 px-6 pb-3 border-b-2 lg:px-10">
                  <span>
                     <InternationalMapIcon width={28} height={28} />
                  </span>
                  <span className="text-lg">
                     <Translate id="onboard:intl reseller" />
                  </span>
                  <span className="w-full text-xs text-grey-200 lg:w-3/4">
                     <Translate id="onboard:intl reseller description" />
                  </span>
               </div>
               <div className="px-6 lg:px-10 py-6 flex flex-col gap-1.5">
                  {IntlUserFeatures?.map((feature, index) => (
                     <div className="flex gap-3" key={index}>
                        <span className="w-5 h-5">
                           <TickMark />
                        </span>
                        <span className="text-sm text-primary">
                           <Translate id={`onboard:${feature}`} />
                        </span>
                     </div>
                  ))}
               </div>
               <div className="mx-6 lg:mx-10 px-6 py-4 flex flex-col bg-grey-600 gap-2 rounded-md border min-h-[145px]">
                  <h6 className="mb-2 text-sm font-semibold">
                     <Translate id="onboard:required legal docs" />
                  </h6>
                  {IntlUserLegalDocs?.map((doc, index) => (
                     <div className="flex gap-3" key={index}>
                        <span className="w-5 h-5">
                           <ReportIcon />
                        </span>
                        <span className="text-sm text-grey-200 -mt-0.5">
                           <Translate id={`onboard:${doc}`} />
                        </span>
                     </div>
                  ))}
               </div>
               <div className="content-end px-6 pt-6 pb-2 mt-auto lg:px-10">
                  <Button
                     className="!w-full h-12 gap-3"
                     theme="outline-primary"
                     onClick={() => {
                        accountTypeSelection('international');
                     }}>
                     <>
                        <Translate id="onboard:get started" />
                     </>
                  </Button>
               </div>
            </div>

            <div className="flex flex-col w-full py-6 bg-white rounded shadow-lg lg:w-1/2">
               <div className="flex flex-col gap-2 px-6 pb-3 border-b-2 lg:px-8">
                  <span className="flex gap-3">
                     <SaudiMapIcon width={28} height={28} />{' '}
                     <span className="text-lg font-semibold">+</span>{' '}
                     <img src="/images/dashboard/kaaba-icon.png" width={28} alt="kaaba" />
                  </span>
                  <span className="text-lg">
                     <Translate id="onboard:domestic provider" />
                  </span>
                  <span className="w-full text-xs text-grey-200 lg:w-3/4">
                     <Translate id="onboard:domestic provider description" />
                  </span>
               </div>
               <div className="px-6 lg:px-8 py-6 flex flex-col gap-1.5">
                  {DomesticUserFeature?.map((feature, index) => (
                     <div className="flex gap-3" key={index}>
                        <span className="w-5 h-5">
                           <TickMark />
                        </span>
                        <span className="text-sm text-primary">
                           <Translate id={`onboard:${feature}`} />
                        </span>
                     </div>
                  ))}
               </div>
               <div className="flex flex-col gap-2 px-6 py-4 mx-6 border rounded-md lg:mx-10 bg-grey-600">
                  <h6 className="mb-2 text-sm font-semibold">
                     <Translate id="onboard:required legal docs" />
                  </h6>
                  {DomesticUserLegalDocs?.map((doc, index) => (
                     <div className="flex gap-3" key={index}>
                        <span className="w-5 h-5">
                           <ReportIcon />
                        </span>
                        <span className="text-xs lg:text-sm text-grey-200 -mt-0.5">
                           <Translate id={`onboard:${doc}`} />
                        </span>
                     </div>
                  ))}
               </div>
               <div className="content-end px-6 pt-6 pb-2 mt-auto lg:px-10">
                  <Button
                     className="!w-full h-12 gap-3"
                     theme="outline-primary"
                     onClick={() => {
                        accountTypeSelection('domestic');
                     }}>
                     <>
                        <Translate id="onboard:get started" />
                     </>
                  </Button>
               </div>
            </div>
         </div>
      </div>
   );
};
